import React from 'react';
import { CheckCircle } from 'lucide-react';
interface LocationHighlightsProps {
  highlights: string[];
  locationName: string;
}
export function LocationHighlights({
  highlights,
  locationName
}: LocationHighlightsProps) {
  return <section className="py-16 bg-white" data-id="element-580">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-581">
        <div className="text-center mb-12" data-id="element-582">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-583">
            Why Train at {locationName}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-584">
          {highlights.map((highlight, index) => <div key={index} className="flex flex-col items-center text-center p-6 bg-slate-50 rounded-xl border border-slate-200" data-id="element-585">
              <div className="flex items-center justify-center w-12 h-12 bg-[#dc2626] rounded-full mb-4" data-id="element-586">
                <CheckCircle className="h-6 w-6 text-white" data-id="element-587" />
              </div>
              <h3 className="text-lg font-bold text-[#1a2332]" data-id="element-588">{highlight}</h3>
            </div>)}
        </div>
      </div>
    </section>;
}